export enum AskPdfApi {
  GetStatus = '/api/v1/documents/:resourceId/status',
  GetInsights = '/api/v1/documents/:resourceId/insights',
  EnsureIndexed = '/api/v1/documents/:resourceId/ensure-indexed',
  CreateConversation = '/api/v1/documents/:resourceId/conversations',
  SendMessage = '/api/v1/conversations/:conversationId/messages'
}
